import React from 'react';
import { translate } from '#packages/i18n';
import { Text } from '@wix/design-system';
import constants from '#packages/constants';
import * as stateManagement from '#packages/stateManagement';
const panelsActions = stateManagement.panels.actions;

import type { EditorAPI } from '#packages/editorAPI';

const { GENERIC_MESSAGE_PANEL } = constants.PANELS;

export const openInvalidSavedElementPanel = (editorAPI: EditorAPI) => {
  const onClose = () =>
    editorAPI.store.dispatch(
      panelsActions.closePanelByNameAction(GENERIC_MESSAGE_PANEL),
    );
  editorAPI.store.dispatch(
    panelsActions.updateOrOpenPanel(
      GENERIC_MESSAGE_PANEL,
      {
        title: translate('MyDesigns_Corrupted_Error_Modal_Title'),
        message: (
          <Text>
            {`${translate('MyDesigns_Corrupted_Error_Modal_Body')} `}
            <a
              onClick={() =>
                editorAPI.panelManager.openHelpCenter(
                  'a7fcc82b-b766-4a66-ac2d-b1648bbbdb46',
                )
              }
            >
              {translate('MyDesigns_Corrupted_Error_Modal_Learn_More_Link')}
            </a>
          </Text>
        ),
        theme: 'destructive',
        confirmLabel: translate('MyDesigns_Corrupted_Error_Modal_Main_CTA'),
        close: onClose,
        onConfirm: onClose,
      },
      true,
    ),
  );
};
